import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearLocalStorageExcept } from './utils/storage';
import { resetStore } from './reducers/resetStore';

export default function ReloadHandler() {
    const dispatch = useDispatch();

    useEffect(() => {
        const handleBeforeUnload = () => {
            clearLocalStorageExcept(['user', 'categories', 'currentIndexId', 'language']);
            dispatch(resetStore());
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [dispatch]);

    return null;
}